import {Record} from 'immutable';

export default class ScorecardSchemeLabel extends Record({
  default: undefined,
  scoringScheme: undefined,
  labels: undefined,
}) {
  constructor(object = {}) {
    super({
      default: object.default,
      scoringScheme: object.scoringScheme,
      labels: object.labels
        ? object.labels.map(l => {
            return {
              label: l.label,
              point: l.point !== null ? l.point + '' : l.point,
            };
          })
        : [],
    });
  }
}
